const BaseApi = "https://datasen.com/job-board-script/api"


export default BaseApi
